<template>
  <div id="app">
    <div id="pageTop"></div>
    <my-nav v-show="isLogged"></my-nav>
    <div class="container-fluid">
      <router-view class="p-2 ml-2 mr-2 mb-2 mt-3"/>
    </div>
    <vue-progress-bar></vue-progress-bar>
    <div id="pageBottom"></div>
    <v-dialog/>
  </div>
</template>

<script>
import store from '@/store';

export default {
  computed: {
    isLogged() {
      return this.$store.getters.isLogged;
    },
  },
}

</script>
